import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { Location } from "@App/Pages/Common/Location";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";

/**
 * The funnel for the certificate service.
 *
 * @constructor
 */
export const Glass: FunctionComponent = () => {
  const { navigateWithQuery } = useServiceFunnel("autoglas-reparatur");

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Location
            headline={"Jetzt Online Autoscheiben-Reparatur buchen"}
            subheadline={"Wo willst du deine Autoscheibe reparieren lassen?"}
            description={" "}
            step={0}
            maxSteps={1}
            onSubmit={() => navigateWithQuery(`werkstaetten`)}
          />
        }
      />
    </Routes>
  );
};
